export default __webpack_public_path__ + "static/media/brain.a299241f.png";